/**
 * wizard-storage.ts — Ghi nhớ của luồng tạo nhân viên AI trên TRÌNH DUYỆT NÀY (sessionStorage, mọi lần đọc / ghi bọc
 * try/catch — trình duyệt chặn bộ nhớ thì luồng vẫn chạy, chỉ quên lượt thử khi tải lại):
 *  - bước xa nhất đã tới + mẫu đã chọn của từng bản nháp;
 *  - các lượt chạy thử (để bước "Chạy thử" và checklist trang Bắt đầu biết đã thử chưa).
 * Không có API lưu lượt thử theo nhân viên AI (phân tích của bot bỏ hội thoại sandbox) — xem báo cáo.
 */
import type { ChatTurn } from '@/components/ai/bot-test-chat'
import type { WizardTemplateKey } from './wizard-templates'

export interface WizardMemo { maxVisited: number; template: WizardTemplateKey | null }

const MEMO_PREFIX = 'ecdp:ai-wizard:'
const TURNS_PREFIX = 'ecdp:ai-wizard-turns:'

function readJson<T>(key: string): T | null {
  try {
    const raw = sessionStorage.getItem(key)
    return raw ? (JSON.parse(raw) as T) : null
  } catch {
    return null
  }
}

function writeJson(key: string, v: unknown) {
  try { sessionStorage.setItem(key, JSON.stringify(v)) } catch { /* bộ nhớ trình duyệt bị chặn — bỏ qua */ }
}

export const readMemo = (botId: string) => readJson<WizardMemo>(MEMO_PREFIX + botId)
export const writeMemo = (botId: string, m: WizardMemo) => writeJson(MEMO_PREFIX + botId, m)
export const readTurns = (botId: string) => readJson<ChatTurn[]>(TURNS_PREFIX + botId) ?? []
export const writeTurns = (botId: string, turns: ChatTurn[]) => writeJson(TURNS_PREFIX + botId, turns)

/** Id các nhân viên AI đã có lượt chạy thử thành công trong luồng tạo (trên trình duyệt này). */
export function testedWizardBotIds(): string[] {
  try {
    const out: string[] = []
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i)
      if (!k?.startsWith(TURNS_PREFIX)) continue
      if ((readJson<ChatTurn[]>(k) ?? []).some((t) => !t.error)) out.push(k.slice(TURNS_PREFIX.length))
    }
    return out
  } catch {
    return []
  }
}
